import update from 'immutability-helper';

import { PAGINATION_LIMIT } from '../../../config';

import { USER_STATE_QUERY } from '../graphql/UserStateQuery.client.gql';

const TYPE_USER_STATE = 'UserState';

const TYPE_USER_STATE_FILTER = 'UserFilterInput';

const TYPE_USER_STATE_PAGINATION = 'UserPaginationInput';

const defaults = {
  userState: {
    filter: {
      username_Icontains: '',
      firstName_Icontains: '',
      lastName_Icontains: '',
      email_Icontains: '',
      __typename: TYPE_USER_STATE_FILTER
    },
    orderBy: ['-id'],
    pagination: {
      first: PAGINATION_LIMIT,
      offset: 0,
      __typename: TYPE_USER_STATE_PAGINATION
    },
    __typename: TYPE_USER_STATE
  }
};

const resolvers = {
  Mutation: {
    updateUserFilter: (_, { filter, orderBy, pagination }, { cache }) => {
      const { userState } = cache.readQuery({
        query: USER_STATE_QUERY
      });
      const newUserState = update(userState, {
        filter: { $merge: filter },
        orderBy: { $set: orderBy },
        pagination: { $merge: pagination }
      });

      cache.writeData({
        data: {
          userState: newUserState,
          __type: TYPE_USER_STATE
        }
      });

      return null;
    }
  }
};

export default { defaults, resolvers };
